import env from '@beam-australia/react-env';
import { Cloudinary } from '@cloudinary/url-gen';
import { fill } from '@cloudinary/url-gen/actions/resize';

const cld = new Cloudinary({
  cloud: { cloudName: env('CLOUDINARY_CLOUD_NAME') },
  url: {
    secure: true,
  },
});

const resizeCloudinaryImage = (publicId, width, height) => {
  const img = cld.image(publicId);
  img.resize(
    fill()
      .width(width)
      .height(height || width),
  );
  return img.toURL();
};

export default resizeCloudinaryImage;
